function t(r, f) {
  return Array.isArray(f) ? f[r] !== void 0 ? " " + f[r] : "" : f ? " " + f : "";
}
export {
  t as getItemBgColor
};
